import { FIELD, FIELD_LABEL, GROUP_TITLE } from "./constants";

const TABLE = "IMLOT";

/**
 * The three groups reproduce the legacy form's pnlBottom, left to right and in its order: grpBottomLeft
 * (the date, Width 305), grpBottomRight (the three checkboxes, Width 305) and grpBottomRightStorage (the
 * two combos, alClient). Three groups is also what makes FormField lay them out side by side — it gives
 * each group col-md-4 — so the web page stands where the Delphi form does without any layout of its own.
 *
 * Field order within each group is the DFM's visual and tab order, taken from the Top values.
 *
 * isLabelChanged: true everywhere so Fields.js uses the literal caption rather than a Localization
 * lookup — these must match the Delphi form and no localization keys exist for them.
 *
 * tableName is IMLOT because the dynamic form wants one and this screen writes to three tables; it only
 * matters for the Localization lookup, which isLabelChanged bypasses anyway.
 *
 * required:
 *  - the date IS required, and that is a deliberate change from AI8. FormAbLoadProgram sets the control
 *    to 0, and ab_DateToSQLStr(0) yields 30/12/1899, so pressing Start without touching it ran four
 *    UPDATEs that matched nothing and still said "Selected items processed successfully." Asking for the
 *    date is better than silently doing nothing; the server requires it on Start too.
 *  - the three checkboxes are required: false. Fields.js emits a static RequiredRule for a checkbox as a
 *    CustomRule demanding `=== true`, which would make every box individually mandatory — the opposite of
 *    three independent options. The real rule is "at least one box or one storage flag", enforced in the
 *    page's selectionIsUsable and again server-side in ValidateRequest.
 *  - the two selects are required: false as well. "Do Nothing" is a legitimate, and the default, answer.
 */
const ParametersLayout = [
    {
        groupId: 1,
        label: GROUP_TITLE.LastUpdateDate,
        fields: [
            {
                name: FIELD.LastUpdateDate,
                tableName: TABLE,
                label: FIELD_LABEL.LastUpdateDate,
                type: "date",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 2,
        label: GROUP_TITLE.Status,
        fields: [
            {
                name: FIELD.UpdateLots,
                tableName: TABLE,
                label: FIELD_LABEL.UpdateLots,
                type: "checkbox",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.UpdateSublots,
                tableName: TABLE,
                label: FIELD_LABEL.UpdateSublots,
                type: "checkbox",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.UpdateUnits,
                tableName: TABLE,
                label: FIELD_LABEL.UpdateUnits,
                type: "checkbox",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 3,
        label: GROUP_TITLE.RecurringStorage,
        fields: [
            {
                name: FIELD.LotRecurringStorage,
                tableName: TABLE,
                label: FIELD_LABEL.LotRecurringStorage,
                type: "select",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.SublotRecurringStorage,
                tableName: TABLE,
                label: FIELD_LABEL.SublotRecurringStorage,
                type: "select",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { ParametersLayout };
